import clsx from 'clsx';

import type { PriceData, Tier } from '../../utils/pricing/types';

interface PriceProps {
  price: PriceData;
  tier: Tier;
  noMargin?: boolean;
}

export function Price(props: PriceProps) {
  const { tier, price, noMargin = false } = props;

  return (
    <p className={clsx('flex items-baseline gap-x-1', !noMargin && 'mt-6')}>
      <span
        className={clsx(
          tier.featured ? 'text-white' : 'text-neutral-900',
          'text-4xl font-semibold tracking-tight',
        )}
      >
        {price.value}
      </span>
      {price.suffix && (
        <span
          className={clsx(
            tier.featured ? 'text-neutral-300' : 'text-neutral-600',
            'text-sm/6 font-semibold',
          )}
        >
          {price.suffix}
        </span>
      )}
    </p>
  );
}
